import {React,useState,useRef} from "react";
import ContactPopup from "../ContactPopup";
// import "./ServicePages.css";
import "../ImportExport/ServicePages.css";
const LLPClosure = () => {
   const [openPopup, setOpenPopup] = useState(false);
  
    const contactRef = useRef(null);
  
    const scrollToContact = () => {
      contactRef.current?.scrollIntoView({ behavior: "smooth" });
    };
  
  return (
    <div className="service-page">

      {/* HERO */}
      <section className="service-hero">
        <h1>LLP Closure Service</h1>
        <p>Strike Off & Winding Up Assistance</p>
         <button className="hero-btn" onClick={scrollToContact} >
            Get Started Today
          </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <p>
          Closing a Limited Liability Partnership (LLP) is a legal process governed by the LLP Act, 2008.
          It involves formally shutting down the LLP and removing its name from the Registrar of Companies (ROC).
        </p>
        <p>
          We provide complete assistance for smooth, compliant, and hassle-free closure of LLPs with proper documentation.
        </p>
      </section>

      {/* METHODS */}
      <section className="service-section">
        <h2>Methods of Closing an LLP</h2>

        <div className="card">
          <h3>1. Strike Off (Fast Track Closure)</h3>
          <ul>
            <li>LLP has no business activity</li>
            <li>No outstanding liabilities</li>
            <li>Bank account is closed or inactive</li>
            <li>Partners mutually agree to close</li>
          </ul>
        </div>

        <div className="card">
          <h3>2. Voluntary Winding Up</h3>
          <ul>
            <li>LLP has assets or liabilities</li>
            <li>Formal liquidation process required</li>
            <li>Settlement with creditors</li>
            <li>Structured closure process</li>
          </ul>
        </div>
      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our LLP Closure Services Include</h2>
        <ul>
          <li>Eligibility check for LLP strike off</li>
          <li>Preparation & filing of Form 24</li>
          <li>Drafting partner consent & resolutions</li>
          <li>Settlement of ROC compliances</li>
          <li>GST & Income Tax de-registration support</li>
          <li>Bank account closure assistance</li>
          <li>End-to-end ROC coordination</li>
        </ul>
      </section>

      {/* WHEN TO CLOSE */}
      <section className="service-section">
        <h2>When Should You Close an LLP?</h2>
        <ul>
          <li>No business activity for a long time</li>
          <li>Business discontinued</li>
          <li>No income or transactions</li>
          <li>To avoid compliance costs</li>
          <li>Business restructuring</li>
        </ul>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>
        <ul>
          <li>LLP Incorporation Certificate</li>
          <li>LLP Agreement</li>
          <li>PAN of LLP</li>
          <li>Financial statements (if applicable)</li>
          <li>Bank account closure proof</li>
          <li>Partner consent</li>
          <li>ID & address proof of partners</li>
        </ul>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of Proper LLP Closure</h2>
        <ul>
          <li>✔ Avoid penalties and compliance burden</li>
          <li>✔ Clean closure with ROC records</li>
          <li>✔ No future filings required</li>
          <li>✔ Prevent legal notices</li>
          <li>✔ Peace of mind</li>
        </ul>
      </section>

      {/* WHY US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>✔ Expert LLP compliance handling</li>
          <li>✔ Fast closure process</li>
          <li>✔ Complete documentation support</li>
          <li>✔ Affordable pricing</li>
          <li>✔ End-to-end assistance</li>
        </ul>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Want to close your LLP legally?</h2>
        <p>We ensure smooth and compliant closure from start to finish.</p>
        <button>Contact Us</button>
      </section> */}
      
<div className="cta" ref={contactRef}>
        <h2>Want to close your LLP legally?</h2>
        <p>We ensure smooth and compliant closure from start to finish.</p>

        <div className="cta-buttons">
          <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
          <ContactPopup
            isOpen={openPopup}
            onClose={() => setOpenPopup(false)}
          />

          <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
        </div>
      </div>
      

    </div>

    
  );
};

export default LLPClosure;